/**
 * @auth 赖传峰
 * @date 2022/4/6
 */
export default (domain: string) => {
  /**
   * NOTICE 之所有不用 process.dev，是因为测试环境用 nuxt build 命令编译，process.dev === false
   * NOTICE 所以需要使用 NODE_ENV 环境变量来控制
   * */
  const isProd = process.env.NODE_ENV === 'production'
  return {
    PP_DRIVE_API: isProd ? `https://api-drive.${domain}` : `https://dev-api-drive.${domain}`,
    PP_USER_API: isProd ? `https://user.${domain}` : `https://dev-user.${domain}`,
    PP_CONFIG_API: isProd ? `https://config.${domain}` : `https://dev-config.${domain}`,
  }
}
